import { Box, Typography, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { LineChart } from "../../../../../components/charts";
import { GraphFooter } from "../../../../../components/parts/graphFooter";

const useStyles = makeStyles(() => ({
  consumptionBlock: {
    position: "absolute",
    top: "41%",
    left: "-26px",
    transform: "translateY(-50%)",
  },
  consumption: {
    color: COLORS.darks[0][100],
    fontSize: 12,
    transform: "rotate(-90deg)",
  },
}));

export const TenancyChart = ({ footerItems, title, chartData, chartLines, ticks }) => {
  const classes = useStyles();

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Typography variant="h4" style={{ marginBottom: 30 }}>
          {title}
        </Typography>
        <Box style={{ position: "relative" }}>
          <Box className={classes.consumptionBlock}>
            <Typography className={classes.consumption}>Tenants</Typography>
          </Box>
          <LineChart
            chartData={chartData}
            chartLines={chartLines}
            dot={false}
            ticks={ticks}
            yTickFormatter={(tick) => `${tick}%`}
            xAxisPadding={{ left: 5, right: 20 }}
            hideSum
            unit="%"
          />
        </Box>
        <GraphFooter
          items={footerItems}
          style={{ marginTop: 6 }}
          typographyStyle={{
            fontSize: 12,
          }}
        />
      </Box>
    </ShaDowBox>
  );
};
